module.exports = __webpack_public_path__ + "static/hiresomeone-1a223326c2dc115682fe6c2a5e1b2327.jpg";